import { NewCourseCardSkeleton } from '@/app/modules/course/components/NewCourseCardSkeleton'
import { ComponentProps, Fragment } from 'react'

type SearchLoadingStateProps = ComponentProps<'div'> & {
  pageSize?: number
  bare?: boolean
}

export function SearchLoadingState({
  pageSize = 6,
  bare,
  ...props
}: SearchLoadingStateProps) {
  const Wrapper = ({ children, ...props }) =>
    bare ? <Fragment>{children}</Fragment> : <div {...props}>{children}</div>

  return (
    <Wrapper {...props}>
      {Array.from({ length: pageSize }).map((_, index) => (
        <NewCourseCardSkeleton key={`loading-item-${index}`} />
      ))}
    </Wrapper>
  )
}
